'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _core = require('./core');

exports.default = {
  initialize: _core.initialize,
  getTracker: _core.getTracker,
  trackPageview: _core.trackPageview,
  trackEvent: _core.trackEvent
}, module.exports = exports.default;